var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCpaProduct } from 'components/Cpa/CpaProduct/CpaProductContextProvider';
import { InputFieldType } from 'models/Input/InputModels';
import { PubTable } from 'components/Shared/PubTable/PubTable';
import Box from '@mui/material/Box';
import { CPA_NOTE_TYPES, checkUserLockPreventsEdit, createLock } from 'utils/cpa-utils';
import { useAuth } from 'services/auth/AuthProvider';
import { useMemo } from 'react';
import { dateFormatHelper } from 'utils/date-format-helper';
import { getUserOrSignIn } from 'services/auth/AuthService';
import { useBanner, BannerMessageType, BannerIconType } from 'components/Shared/BannerContext/BannerContext';
export function NotesTable(_a) {
    var _this = this;
    var _b, _c;
    var _d = _a.showAddRow, showAddRow = _d === void 0 ? false : _d, showAddRowAction = _a.showAddRowAction;
    var user = useAuth();
    var cpaProductContext = useCpaProduct();
    var _e = useBanner(), setBannerMessage = _e.setBannerMessage, setBannerType = _e.setBannerType, setBannerIcon = _e.setBannerIcon, setShowBanner = _e.setShowBanner;
    var tableData = useMemo(function () {
        var _a, _b, _c;
        var data = {};
        var productNotes = __spreadArray([], ((_b = (_a = cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.currentProduct) === null || _a === void 0 ? void 0 : _a.productNotes) !== null && _b !== void 0 ? _b : []), true);
        (_c = productNotes
            .sort(function (a, b) {
            var _a, _b;
            var aTime = new Date((_a = a.maintDtm) !== null && _a !== void 0 ? _a : 0).getTime();
            var bTime = new Date((_b = b.maintDtm) !== null && _b !== void 0 ? _b : 0).getTime();
            return aTime > bTime ? -1 : 1;
        })) === null || _c === void 0 ? void 0 : _c.forEach(function (note) {
            data[crypto.randomUUID()] = note;
        });
        return data;
    }, [(_b = cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.currentProduct) === null || _b === void 0 ? void 0 : _b.productNotes]);
    var tableDataDefinition = {
        firstColumnIndent: true,
        noDataMessage: 'No Notes',
        addRowWhenNoData: false,
        columns: [
            {
                dataAttribute: 'maintDtm',
                fieldType: InputFieldType.READONLY,
                heading: 'Timestamp',
                formatter: function (value) { return dateFormatHelper.formatIsoString(value, true, true); },
                width: '172px',
            },
            {
                dataAttribute: 'noteType',
                fieldType: InputFieldType.ENUM,
                heading: 'Note Type',
                allowedFieldValues: Object.keys(CPA_NOTE_TYPES),
                defaultValue: undefined,
                validations: {
                    required: 'Note Type required.',
                },
                width: '144px',
            },
            {
                dataAttribute: 'title',
                fieldType: InputFieldType.STRING,
                heading: 'Title',
                defaultValue: '',
                validations: {
                    required: 'Title input required.',
                },
                width: '144px',
            },
            {
                dataAttribute: 'note',
                fieldType: InputFieldType.STRING,
                heading: 'Note',
                defaultValue: '',
                validations: {
                    required: 'Note input required.',
                },
            },
            {
                dataAttribute: 'userId',
                fieldType: InputFieldType.READONLY,
                heading: 'User',
                defaultValue: (_c = user.user) === null || _c === void 0 ? void 0 : _c.email,
                width: '200px',
            },
        ],
        showAddRow: showAddRow,
        showAddRowHandler: showAddRowAction,
        disableEdit: function (key) {
            var _a, _b;
            var rowNotInOriginal = JSON.stringify((_b = (_a = cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.currentProductOriginal) === null || _a === void 0 ? void 0 : _a.productNotes) !== null && _b !== void 0 ? _b : []).includes(JSON.stringify(tableData[key]));
            return rowNotInOriginal || checkUserLockPreventsEdit(cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.cpn);
        },
        editHandler: function (key, row) { return __awaiter(_this, void 0, void 0, function () {
            var updatedNote;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        updatedNote = {
                            maintDtm: row.maintDtm,
                            noteType: row.noteType,
                            title: row.title,
                            note: row.note,
                            userId: (_a = user.user) === null || _a === void 0 ? void 0 : _a.email,
                        };
                        tableData[key] = updatedNote;
                        dispatchUpdateProductNotes();
                        return [4 /*yield*/, handleCreateLock()];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        addHandler: function (row) { return __awaiter(_this, void 0, void 0, function () {
            var newNote;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        newNote = {
                            maintDtm: new Date().toISOString(),
                            noteType: row.noteType,
                            title: row.title,
                            note: row.note,
                            userId: (_a = user.user) === null || _a === void 0 ? void 0 : _a.email,
                        };
                        tableData[crypto.randomUUID()] = newNote;
                        dispatchUpdateProductNotes();
                        return [4 /*yield*/, handleCreateLock()];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        deleteProps: {
            deleteHandler: function (key) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, handleCreateLock()];
                        case 1:
                            if (_a.sent()) {
                                delete tableData[key];
                                dispatchUpdateProductNotes();
                            }
                            return [2 /*return*/];
                    }
                });
            }); },
            disabled: cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.isEditDisabled,
            modalProps: {
                buttonProps: {
                    confirmText: 'Delete Note',
                    cancelText: 'Keep Note',
                },
                titleText: 'Delete Notes',
                bodyTextArray: ['Are you sure you would like to delete this note? This action is permanent.'],
            },
        },
    };
    function dispatchUpdateProductNotes() {
        if (cpaProductContext && cpaProductContext.data.currentProduct) {
            cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.dispatch({
                type: 'UPDATE_PRODUCT_NOTES',
                payload: Object.values(tableData !== null && tableData !== void 0 ? tableData : {}),
            });
        }
    }
    function handleCreateLock() {
        return __awaiter(this, void 0, void 0, function () {
            var cpn, sessionId, lockUser, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cpn = cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.cpn;
                        sessionId = sessionStorage.getItem("".concat(cpn, "_identifier"));
                        if (!(cpn && sessionId)) return [3 /*break*/, 5];
                        return [4 /*yield*/, getUserOrSignIn()];
                    case 1:
                        lockUser = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, createLock(cpn, user.user.name, sessionId, cpaProductContext.data.currentProduct.startDate)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        setBannerMessage('Failed to create lock!');
                        setBannerType(BannerMessageType.Warning);
                        setBannerIcon(BannerIconType.Error);
                        setShowBanner(true);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/, !checkUserLockPreventsEdit(cpn)];
                }
            });
        });
    }
    return (_jsx(Box, { children: _jsx(PubTable, { def: tableDataDefinition, tableData: tableData }) }));
}
